import React from 'react';

interface Props extends React.SVGProps<SVGSVGElement> {
  width?: string | number;
  height?: string | number;
  fill?: string;
}
const Download: React.FC<Props> = ({
  width = '24',
  height = '24',
  fill = 'white',
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <rect
        x="0.656249"
        y="0.656249"
        width="22.6875"
        height="22.6875"
        rx="3.35631"
        stroke="white"
        strokeWidth="1.3125"
      />
      <path
        d="M12.0002 4.61523V15.6922M12.0002 15.6922L7.38477 11.0768M12.0002 15.6922L16.6155 11.0768"
        stroke="white"
        strokeWidth="1.3125"
      />
      <path d="M5.53809 18.4629H18.4612" stroke="white" strokeWidth="1.3125" />
    </svg>
  );
};

export default Download;
